import { groupBy, prop } from 'rambda'

export default function buildLaptopBuckets() {
  const { isBucketView, laptopIdsSelected, laptopEvaluationsSorted } = this

  if (!isBucketView) {
    return [
      { laptops: laptopEvaluationsSorted },
    ]
  }

  const dollars = price => this
    .$options
    .filters
    .currency(price, '$', 0)

  const laptopsSelected = laptopEvaluationsSorted
    .filter(({ id }) => laptopIdsSelected.includes(id))

  const laptopsSelectedByBucketPrice = groupByBucket(laptopsSelected)
  const laptopsGrouped = groupByBucket(laptopEvaluationsSorted)

  const laptopBuckets = (this.criteria.buckets || [])
    .map(({ limit, price }) => {
      const bucketLaptops = laptopsGrouped[price] || []
      const bucketLaptopsSelected = laptopsSelectedByBucketPrice[price] || []
      const bucketLaptopsSliced = bucketLaptops.slice(0, limit)

      const bucketLaptopsToLift = bucketLaptopsSelected
        .filter(laptop => !bucketLaptopsSliced.includes(laptop))

      const bucketLaptopsRearranged = bucketLaptopsToLift.length
        ? [...bucketLaptopsToLift, ...bucketLaptopsSliced].slice(0, limit)
        : bucketLaptopsSliced

      return {
        total: bucketLaptops.length,
        label: this.$t('under', [dollars(price)]),
        laptops: bucketLaptopsRearranged,
      }
    })

  this.laptopBuckets = laptopBuckets
}

const groupByBucket = groupBy(prop('bucketPrice'))
